import shipmentMixin from "@/mixins/shipment/shipmentMixin";
import {mapGetters} from "vuex";

export default {
	extends: shipmentMixin,
	computed: {
		...mapGetters([
			"getShipmentsPackagesById",
			"getShipmentsByPackageId",
			"getShipmentsPackagesFullLoadById",
		]),
		shipmentsPackage() {
			return this.getShipmentsPackagesById[this.packageId || this.shipment?.package_id]
		},
		packageShipments() {
			return this.getShipmentsByPackageId[this.packageId] || []
		},
		isShipmentsPackageFullLoad() {
			return this.getShipmentsPackagesFullLoadById[this.packageId]
		},
		firstShipmentPackage() {
			return this.packageShipments[0]
		},
		routes() {
			return this.packageId ? (this.shipmentsPackage?.routes || this.firstShipmentPackage?.routes) : this.shipment?.routes;
		},
		name() {
			return this.shipment?.name || this.shipmentsPackage?.name
		},
		shipmentsNotes() {
			return this.packageShipments?.length
				? this.packageShipments?.map(s => ({name: s.name, notes: s.notes || []}))
				: [{name: '', notes: this.shipment?.notes || []}]
		},
		notesCount() {
			let notes = this.shipmentsNotes?.reduce((count, s) => {
				count = count + (s?.notes?.length || 0)
				return count
			}, 0)
			if(this.packageId || this.shipment?.package_id) {
				if(this.shipmentId) {
					notes += (this.shipmentsPackage?.notes?.length || 0)
				}
			}
			return notes
		},
	}
}